import type { ApprovalOption } from '../components/ComparisonTabs'

interface DealCubeHistoryDetailBase {
  level?: string | number | null
  approversByLevel?: Array<{
    roleTitle: string | null
    decisionReasonCode: string | null
  }>
}

export const getApprovalOptions = (
  dealCubeHistoryDetails: DealCubeHistoryDetailBase[]
): ApprovalOption[] => {
  const options: ApprovalOption[] = []

  dealCubeHistoryDetails.forEach((detail) => {
    if (!detail || detail.level === undefined || detail.level === null) return

    const approvers = detail.approversByLevel ?? []
    if (approvers.length === 0) return

    const level = String(detail.level).trim()
    // Include all parallel approver groups at this level, not just the first one
    approvers.forEach((approver) => {
      if (!approver || !approver.decisionReasonCode) return

      const { decisionReasonCode, roleTitle } = approver

      const id = `${level}-${decisionReasonCode}`
      if (!options.some((o) => o.id === id)) {
        options.push({
          id,
          label: `${decisionReasonCode} - ${roleTitle ?? ''}`,
        })
      }
    })
  })

  return options
}
